import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    const { user } = response.data;
    
    localStorage.setItem('user', JSON.stringify(user));
    
    return { user };
  },

  async register(userData) {
    const response = await api.post('/auth/register', userData);
    const { user } = response.data;
    
    localStorage.setItem('user', JSON.stringify(user));
    
    return { user };
  },

  logout() {
    localStorage.removeItem('user');
  },

  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!this.getCurrentUser();
  },

  isAdmin() {
    const user = this.getCurrentUser();
    return user?.role === 'admin';
  }
};